// Fonte: UManutContas.pas ~linha 12488, dsJUro → tabela Conta_Juro_Auto
// Disponível para: Tipos 1, 4, 6, 8
// PK: Sequencia + Codigo_Conta + Codigo_Grupo_Empresa (MAX+1 para Sequencia)
import React, { useState, useEffect, useCallback } from 'react';
import { Table, Button, Form, Modal, Spinner, Row, Col } from 'react-bootstrap';
import Select from 'react-select';
import { toast } from 'react-toastify';
import {
  listarJurosAutoConta,
  inserirJurosAutoConta,
  atualizarJurosAutoConta,
  excluirJurosAutoConta,
  listarMoedasContas,
  listarTodosGruposEmpresa,
  listarUsuariosJuros,
  listarContasIntercambio,
} from '~/Services/Service';
import moment from 'moment';

var VAZIO = {
  ativo: '',
  tx_deb: '',
  tx_cred: '',
  mo_correcao: '',
  mo_correcao_debito: '',
  inter_ge: '',
  inter_cre: '',
  inter_deb: '',
  codigo_usuario_resp: '',
  data_termino: '',
};

// Fonte: UManutContas.pas ~linha 11567 — quando Ativo = 200011, oculta taxas e intercâmbio
var ATIVO_SEM_TAXAS = 200011;

var TabJurosAuto = function(_ref) {
  var ge = _ref.ge;
  var codigo = _ref.codigo;

  var [lista, setLista] = useState([]);
  var [moedas, setMoedas] = useState([]);
  var [gruposEmpresa, setGruposEmpresa] = useState([]);
  var [usuarios, setUsuarios] = useState([]);
  var [contasIntercambio, setContasIntercambio] = useState([]);
  var [loading, setLoading] = useState(false);
  var [showModal, setShowModal] = useState(false);
  var [editando, setEditando] = useState(null);
  var [form, setForm] = useState(VAZIO);
  var [salvando, setSalvando] = useState(false);
  var [showExcluir, setShowExcluir] = useState(null);

  var ocultarTaxas = form.ativo !== '' && Number(form.ativo) === ATIVO_SEM_TAXAS;

  var carregar = useCallback(function() {
    if (!ge || !codigo) return;
    setLoading(true);
    listarJurosAutoConta(ge, codigo)
      .then(function(resp) {
        setLista(Array.isArray(resp) ? resp : []);
      })
      .catch(function() { toast.error('Erro ao carregar juros automáticos'); })
      .finally(function() { setLoading(false); });
  }, [ge, codigo]);

  useEffect(function() {
    carregar();
    Promise.all([
      listarMoedasContas(),
      listarTodosGruposEmpresa(),
      listarUsuariosJuros(),
    ]).then(function(results) {
      var moedasData = Array.isArray(results[0]) ? results[0] : [];
      setMoedas(moedasData.map(function(m) {
        return { value: m.codigo, label: m.codigo + ' - ' + (m.descricao !== null && m.descricao !== undefined ? m.descricao : '') };
      }));

      var geData = Array.isArray(results[1]) ? results[1] : [];
      setGruposEmpresa(geData.map(function(g) {
        return { value: g.codigo, label: g.codigo + ' - ' + (g.apelido !== null && g.apelido !== undefined ? g.apelido : '') };
      }));

      var usuData = Array.isArray(results[2]) ? results[2] : [];
      setUsuarios(usuData.map(function(u) {
        return { value: u.codigo, label: u.descricao !== null && u.descricao !== undefined ? u.descricao : String(u.codigo) };
      }));
    }).catch(function() {});
  }, [carregar]);

  // Fonte: UManutContas.pas ~8049 RxGEJuroChange — recarrega contas quando GE muda
  var carregarContasPorGe = useCallback(function(geIntercambio) {
    if (!geIntercambio && geIntercambio !== 0) {
      setContasIntercambio([]);
      return;
    }
    listarContasIntercambio(geIntercambio)
      .then(function(resp) {
        var data = Array.isArray(resp) ? resp : [];
        setContasIntercambio(data.map(function(c) {
          return { value: c.codigo, label: c.codigo + ' - ' + (c.descricao !== null && c.descricao !== undefined ? c.descricao : '') };
        }));
      })
      .catch(function() { setContasIntercambio([]); });
  }, []);

  var handleNovo = function() {
    setEditando(null);
    setForm({ ...VAZIO });
    setContasIntercambio([]);
    setShowModal(true);
  };

  var handleEditar = function(item) {
    setEditando(item);
    setForm({
      ativo: item.ativo !== null && item.ativo !== undefined ? item.ativo : '',
      tx_deb: item.tx_deb !== null && item.tx_deb !== undefined ? item.tx_deb : '',
      tx_cred: item.tx_cred !== null && item.tx_cred !== undefined ? item.tx_cred : '',
      mo_correcao: item.mo_correcao !== null && item.mo_correcao !== undefined ? item.mo_correcao : '',
      mo_correcao_debito: item.mo_correcao_debito !== null && item.mo_correcao_debito !== undefined ? item.mo_correcao_debito : '',
      inter_ge: item.inter_ge !== null && item.inter_ge !== undefined ? item.inter_ge : '',
      inter_cre: item.inter_cre !== null && item.inter_cre !== undefined ? item.inter_cre : '',
      inter_deb: item.inter_deb !== null && item.inter_deb !== undefined ? item.inter_deb : '',
      codigo_usuario_resp: item.codigo_usuario_resp !== null && item.codigo_usuario_resp !== undefined ? item.codigo_usuario_resp : '',
      data_termino: item.data_termino ? moment(item.data_termino).format('YYYY-MM-DD') : '',
    });
    // Carrega contas do GE selecionado para preencher Creditada/Debitada
    if (item.inter_ge !== null && item.inter_ge !== undefined && item.inter_ge !== '') {
      carregarContasPorGe(item.inter_ge);
    } else {
      setContasIntercambio([]);
    }
    setShowModal(true);
  };

  var handleGeChange = function(opt) {
    var novoGe = opt ? opt.value : '';
    setForm(function(f) {
      return { ...f, inter_ge: novoGe, inter_cre: '', inter_deb: '' };
    });
    if (novoGe !== '' && novoGe !== null) {
      carregarContasPorGe(novoGe);
    } else {
      setContasIntercambio([]);
    }
  };

  var handleSalvar = function() {
    if (!form.ativo && form.ativo !== 0) {
      toast.warning('Ativo é obrigatório');
      return;
    }
    var payload = {
      ativo: form.ativo,
      tx_deb: form.tx_deb !== '' ? Number(form.tx_deb) : 0,
      tx_cred: form.tx_cred !== '' ? Number(form.tx_cred) : 0,
      mo_correcao: form.mo_correcao !== '' ? form.mo_correcao : null,
      mo_correcao_debito: form.mo_correcao_debito !== '' ? form.mo_correcao_debito : null,
      inter_ge: form.inter_ge !== '' ? form.inter_ge : null,
      inter_cre: form.inter_cre !== '' ? form.inter_cre : null,
      inter_deb: form.inter_deb !== '' ? form.inter_deb : null,
      codigo_usuario_resp: form.codigo_usuario_resp !== '' ? form.codigo_usuario_resp : null,
      data_termino: form.data_termino !== '' ? form.data_termino : null,
    };
    if (editando) {
      payload.sequencia = editando.sequencia;
    }
    setSalvando(true);
    var fn = editando
      ? atualizarJurosAutoConta(ge, codigo, payload)
      : inserirJurosAutoConta(ge, codigo, payload);
    fn
      .then(function() {
        toast.success('Juro automático salvo!');
        setShowModal(false);
        carregar();
      })
      .catch(function() { toast.error('Erro ao salvar juro automático'); })
      .finally(function() { setSalvando(false); });
  };

  var handleExcluir = function() {
    excluirJurosAutoConta(ge, codigo, { sequencia: showExcluir.sequencia })
      .then(function() {
        toast.success('Juro automático excluído!');
        setShowExcluir(null);
        carregar();
      })
      .catch(function() { toast.error('Erro ao excluir juro automático'); });
  };

  var handleChange = function(e) {
    var campo = e.target.name;
    var valor = e.target.value;
    setForm(function(f) { return { ...f, [campo]: valor }; });
  };

  return (
    <div className="contas-tab-content">
      <div className="d-flex justify-content-end mb-2">
        <Button size="sm" variant="primary" onClick={handleNovo}>+ Incluir</Button>
      </div>
      {loading ? (
        <div className="text-center py-3"><Spinner animation="border" /></div>
      ) : (
        <Table size="sm" bordered className="contas-sub-grid">
          <thead>
            <tr>
              <th>Seq</th>
              <th>Ativo</th>
              <th>Tx.Déb</th>
              <th>Mo.Corr.Déb</th>
              <th>Tx.Créd</th>
              <th>Mo.Cor.</th>
              <th>GE</th>
              <th>Creditada</th>
              <th>Debitada</th>
              <th>Dt.Término</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            {lista.length === 0 ? (
              <tr><td colSpan={11} className="text-center text-muted">Nenhum juro automático</td></tr>
            ) : (
              lista.map(function(item) {
                return (
                  <tr key={item.sequencia}>
                    <td>{item.sequencia}</td>
                    <td>{item.apelido_ativo !== null && item.apelido_ativo !== undefined ? item.apelido_ativo : item.ativo}</td>
                    <td>{item.tx_deb !== null && item.tx_deb !== undefined ? item.tx_deb : '-'}</td>
                    <td>{item.mo_correcao_debito !== null && item.mo_correcao_debito !== undefined ? item.mo_correcao_debito : '-'}</td>
                    <td>{item.tx_cred !== null && item.tx_cred !== undefined ? item.tx_cred : '-'}</td>
                    <td>{item.mo_correcao !== null && item.mo_correcao !== undefined ? item.mo_correcao : '-'}</td>
                    <td>{item.inter_ge !== null && item.inter_ge !== undefined ? item.inter_ge : '-'}</td>
                    <td>{item.inter_cre !== null && item.inter_cre !== undefined ? item.inter_cre : '-'}</td>
                    <td>{item.inter_deb !== null && item.inter_deb !== undefined ? item.inter_deb : '-'}</td>
                    <td>{item.data_termino ? moment(item.data_termino).format('DD/MM/YYYY') : '-'}</td>
                    <td>
                      <Button size="sm" variant="outline-primary" className="mr-1" onClick={function() { handleEditar(item); }}>Editar</Button>
                      <Button size="sm" variant="outline-danger" onClick={function() { setShowExcluir(item); }}>Excluir</Button>
                    </td>
                  </tr>
                );
              })
            )}
          </tbody>
        </Table>
      )}

      <Modal show={showModal} onHide={function() { setShowModal(false); }} size="xl">
        <Modal.Header closeButton className="contas-modal-header">
          <Modal.Title>{editando ? 'Editar Juro Automático' : 'Incluir Juro Automático'}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Row>
            <Col md={4}>
              <Form.Group>
                <Form.Label className="small">Ativo *</Form.Label>
                <Select
                  placeholder="Selecione..."
                  options={moedas}
                  value={moedas.find(function(m) { return String(m.value) === String(form.ativo); }) || null}
                  onChange={function(opt) { setForm(function(f) { return { ...f, ativo: opt ? opt.value : '' }; }); }}
                  isClearable
                  noOptionsMessage={function() { return 'Nenhum ativo'; }}
                />
              </Form.Group>
            </Col>
            <Col md={4}>
              <Form.Group>
                <Form.Label className="small">Usu. Responsável</Form.Label>
                <Select
                  placeholder="Selecione..."
                  options={usuarios}
                  value={usuarios.find(function(u) { return String(u.value) === String(form.codigo_usuario_resp); }) || null}
                  onChange={function(opt) { setForm(function(f) { return { ...f, codigo_usuario_resp: opt ? opt.value : '' }; }); }}
                  isClearable
                  noOptionsMessage={function() { return 'Nenhum usuário'; }}
                />
              </Form.Group>
            </Col>
            <Col md={4}>
              <Form.Group>
                <Form.Label className="small">Dt. Término</Form.Label>
                <Form.Control type="date" size="sm" name="data_termino" value={form.data_termino} onChange={handleChange} />
              </Form.Group>
            </Col>
          </Row>

          {!ocultarTaxas && (
            <React.Fragment>
              <Row className="mt-2">
                <Col md={2}>
                  <Form.Group>
                    <Form.Label className="small">Tx. Crédito</Form.Label>
                    <Form.Control type="number" size="sm" step="0.01" min="0" name="tx_cred" value={form.tx_cred} onChange={handleChange} />
                  </Form.Group>
                </Col>
                <Col md={2}>
                  <Form.Group>
                    <Form.Label className="small">Tx. Débito</Form.Label>
                    <Form.Control type="number" size="sm" step="0.01" min="0" name="tx_deb" value={form.tx_deb} onChange={handleChange} />
                  </Form.Group>
                </Col>
                <Col md={4}>
                  <Form.Group>
                    <Form.Label className="small">Mo. Correção</Form.Label>
                    <Select
                      placeholder="Selecione..."
                      options={moedas}
                      value={moedas.find(function(m) { return String(m.value) === String(form.mo_correcao); }) || null}
                      onChange={function(opt) { setForm(function(f) { return { ...f, mo_correcao: opt ? opt.value : '' }; }); }}
                      isClearable
                      noOptionsMessage={function() { return 'Nenhuma moeda'; }}
                    />
                  </Form.Group>
                </Col>
                <Col md={4}>
                  <Form.Group>
                    <Form.Label className="small">Mo. Correção Débito</Form.Label>
                    <Select
                      placeholder="Selecione..."
                      options={moedas}
                      value={moedas.find(function(m) { return String(m.value) === String(form.mo_correcao_debito); }) || null}
                      onChange={function(opt) { setForm(function(f) { return { ...f, mo_correcao_debito: opt ? opt.value : '' }; }); }}
                      isClearable
                      noOptionsMessage={function() { return 'Nenhuma moeda'; }}
                    />
                  </Form.Group>
                </Col>
              </Row>

              <p className="small font-weight-bold mt-3 mb-1">Intercâmbio</p>
              <Row>
                <Col md={4}>
                  <Form.Group>
                    <Form.Label className="small">GE</Form.Label>
                    <Select
                      placeholder="Selecione..."
                      options={gruposEmpresa}
                      value={gruposEmpresa.find(function(g) { return String(g.value) === String(form.inter_ge); }) || null}
                      onChange={handleGeChange}
                      isClearable
                      noOptionsMessage={function() { return 'Nenhum grupo empresa'; }}
                    />
                  </Form.Group>
                </Col>
                <Col md={4}>
                  <Form.Group>
                    <Form.Label className="small">Creditada</Form.Label>
                    <Select
                      placeholder={form.inter_ge ? 'Selecione...' : 'Selecione GE primeiro'}
                      options={contasIntercambio}
                      value={contasIntercambio.find(function(c) { return String(c.value) === String(form.inter_cre); }) || null}
                      onChange={function(opt) { setForm(function(f) { return { ...f, inter_cre: opt ? opt.value : '' }; }); }}
                      isClearable
                      isDisabled={!form.inter_ge}
                      noOptionsMessage={function() { return 'Nenhuma conta'; }}
                    />
                  </Form.Group>
                </Col>
                <Col md={4}>
                  <Form.Group>
                    <Form.Label className="small">Debitada</Form.Label>
                    <Select
                      placeholder={form.inter_ge ? 'Selecione...' : 'Selecione GE primeiro'}
                      options={contasIntercambio}
                      value={contasIntercambio.find(function(c) { return String(c.value) === String(form.inter_deb); }) || null}
                      onChange={function(opt) { setForm(function(f) { return { ...f, inter_deb: opt ? opt.value : '' }; }); }}
                      isClearable
                      isDisabled={!form.inter_ge}
                      noOptionsMessage={function() { return 'Nenhuma conta'; }}
                    />
                  </Form.Group>
                </Col>
              </Row>
            </React.Fragment>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={function() { setShowModal(false); }}>Cancelar</Button>
          <Button variant="success" onClick={handleSalvar} disabled={salvando}>
            {salvando ? <Spinner animation="border" size="sm" /> : 'Gravar'}
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal show={!!showExcluir} onHide={function() { setShowExcluir(null); }}>
        <Modal.Header closeButton className="contas-modal-header"><Modal.Title>Confirmar Exclusão</Modal.Title></Modal.Header>
        <Modal.Body>Deseja excluir o juro automático seq. <strong>{showExcluir && showExcluir.sequencia}</strong>?</Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={function() { setShowExcluir(null); }}>Não</Button>
          <Button variant="danger" onClick={handleExcluir}>Excluir</Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default TabJurosAuto;
